<template lang="pug">
  div(
    style="width: 100%;"
  )

    // Topbar Navigation Menu
    el-row(class="nav-container")
      el-col(:span="20" :offset="3")
        ul(class="navigation")
          li(v-if="adminLoggedIn && showLogout" @click="onLogout")
            a(href="#")
              span Logout
          li(v-if="adminLoggedIn"
            :class="[!isFaq  ? 'li-selected': '']"
            @click="isFaq=false")
            a(href="#")
              span Question Library  
          li(
            :class="[isFaq  ? 'li-selected': '']"
            @click="isFaq=true")
            a(href="#")
              span Home
              

    // Content
    el-main
      el-row(style="margin: 2%;")
        el-col(
          :span="24" )
        
          // FAQ
          faq-info-view(
            v-if="isFaq"
            :isAdminLogin="adminLoggedIn"
            @onFaqsLoaded="isLoginEnabled=true")
    
          login(
            v-if="!adminLoggedIn && isLoginVisible"
            :showLogin="isLoginVisible"
            @onLogin="onLogin"
            @closeLogin="isLoginVisible=false")

          div(
            v-if="adminLoggedIn && !isFaq"
          )
            // Question Library
            question-master-library(
              v-if="libraryType != null"
              :libraryType="libraryType"
              @showLibraryModal="showLibraryModal = true"
            )
            // Library Type Modal
            library-selector-modal(
              :visible-prop="showLibraryModal"
              @close="showLibraryModal = false"
              @formCancelClicked="showLibraryModal = false"
              @selectLibrary="showLibrary"
            )
            

</template>

<script>
import FaqInfoView from '@/components/superadmin/FAQInfoView'
import Login from '@/components/superadmin/Login'
import LibrarySelectorModal from '@/components/instructor/Library/LibrarySelectorModal'
import QuestionMasterLibrary from '@/components/superadmin/QuestionMasterLibrary'
import utilMixin from '@/components/mixins/utilMixin'

export default {
  name: 'Dashboard',

  components: {
    LibrarySelectorModal,
    QuestionMasterLibrary,
    FaqInfoView,
    Login,
  },

  mixins: [utilMixin],

  data() {
    return {
      isFaq: true,
      adminLoggedIn: false,
      isLoginVisible: false,
      isLoginEnabled: false,
      showLibraryModal: false,
      libraryType: null,
    }
  },

  computed: {
    showLogout() {
      return (this.$store.state.adminData.userId === null || this.$store.state.canvasData.userId === null)
    },
  },

  created() {
    this.mThirdPartyCookiesEnabled()
  },

  mounted() {
    this.checkLogin()
  },

  methods: {
    checkLogin() {
      this.axios.post('/api/checklogin')
        .then((result) => {
          if (result.data.isLogin) {
            this.adminLoggedIn = true
            this.$store.commit('setAdminInfo', result.data.user)
            this.showLibraryModal = true
          }

          if (this.mIsBrowserIE()) {
            this.mNotification({title: "Warning",
            plain: 'We have detected that you are using Internet Explorer. We highly recommend to use other browsers such as Chrome, Firefox, Safari  or Edge for a smoother user experience.'})
          }
        })
        .catch((error) => {
          this.mNotification({error: error, message: 'An error has occured while checking login. ' + error})
        })
    },

    showLibrary(type) {
      this.libraryType = type
      this.showLibraryModal = false
    },

    onLogin(success) {
      if (success) {
        this.adminLoggedIn = true
        this.isLoginVisible = false
      } else {
        this.mNotification({message: 'An error has occured while signing in.'})
      }
    },

    onLogout() {
      this.axios('/api/logout')
        .then((result) => {
          this.axios.defaults.headers.common['X-CSRF-TOKEN'] = result.data.csrfToken
          this.adminLoggedIn = false
          this.isFaq = true
          this.$store.state.adminData = {
            userId: null,
            userFirstName: null,
          }
        })
        .catch((error) => {
          this.mNotification({error: error, message: 'And error has occured while signing out.'})
        })
    },
  },
}
</script>


<style module>
.nav-container {
  background: #37474f;
}

.navigation {
  list-style-type: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.navigation li {
  float: right;
  min-width: 100px;
  padding: 12px 16px 16px 16px;
}

.navigation li a {
  display: block;
  font-size: 1em;
  color:#fff;
  text-align: center; 
  text-decoration: none;
}

.navigation li:hover {
  background: #222d35;
}

.navigation .li-selected {
   background: #039be5;
}

</style>
